// extracted by mini-css-extract-plugin
export default {"cardContainer":"ContactCardsContainer_cardContainer__b24xk","cards":"ContactCardsContainer_cards__kAE0O","addressCard":"ContactCardsContainer_addressCard__CJMWm"};